module.exports = __webpack_public_path__ + "fee29270e0fbefd49e38a8f72553ae74.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_30.mp3
// module id = 452
// module chunks = 0